import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialAngularModule } from '../material-design/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { StepperOverviewComponent } from './stepper-overview.component';
import { ContratoModule } from '../contrato/contrato.module';
import { ParcelasComponent } from '../parcelas/parcelas.component';
import { ContractsComponent } from '../contracts/contracts.component';

@NgModule({
  declarations: [
    StepperOverviewComponent,
    ParcelasComponent,
    ContractsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialAngularModule,
    FlexLayoutModule,
    ContratoModule
  ],
  exports: [
    StepperOverviewComponent
  ]
})
export class StepperOverviewModule { }
